export default __webpack_public_path__ + "static/media/printing-block2.ff8926d8.png";